
import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdminManagePaymentById from "../../../../components/PageComponents/AdminComponents/AdminManagePaymentById/AdminManagePaymentById";

const AdminManagePaymentsPage: React.FC = () => {
  return (
    <div className="manage-payments-container">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="fetch-orders-content"
          id="fetch-orders-header"
        >
          Manage payment by Id
        </AccordionSummary>
        <AccordionDetails>
          <AdminManagePaymentById />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AdminManagePaymentsPage;

